const TYPES = [
  { label: 'allCommunityVoices', value: 'trending' },
  { label: 'emergingVoice', value: 'emerging' },
];

const LIMIT_GET_DETAIL_LEADERBOARD_EVENT = 10;
const DAYS_IN_LAST_DAYS_HIGHTLIGHT_WEEK = 7;

export {
  TYPES,
  LIMIT_GET_DETAIL_LEADERBOARD_EVENT,
  DAYS_IN_LAST_DAYS_HIGHTLIGHT_WEEK,
};
